// extracted by mini-css-extract-plugin
module.exports = {"nft":"NFT_nft__2mCBq","container":"NFT_container__38qbj","minuteArm":"NFT_minuteArm__1456c","hourArm":"NFT_hourArm__2CmgZ","minute":"NFT_minute__D5tQl","hour":"NFT_hour__2JfJM"};